import { useAnalyticContext } from '@application/analytic/analytic_link/mod';
import { useFeatureFlag } from '@application/feature_flags/use_feature_flag';
import { withTranslation } from '@application/i18n/with_translation';
import { UniversalConfig } from '@application/universal_config.service';
import { IllustrativeView } from '@component/illustrative_view.component';
import { TopBar } from '@component/top_bar.component';
import { getAbsoluteRoute } from '@module/get_absolute_route';
import { useResolve } from '@visiba/instantiation';
import { useEffect } from 'react';
import { Route, Routes, useParams } from 'react-router';
import { useSearchParams } from 'react-router-dom';

export function ScreenDone() {
	return (
		<>
			<TopBar.Content goBack />
			<Routes>
				<Route path=':ticket' element={<DoneInner />} />
				<Route path='*' element={<DoneInner />} />
			</Routes>
		</>
	);
}

function DoneInner() {
	const params = useParams();
	const [searchParams] = useSearchParams();
	const isReschedule = searchParams.get('reschedule') === 'true';
	const universalConfig = useResolve(UniversalConfig);
	const analyticCtx = useAnalyticContext();
	// TODO: Move this behavior into configuration instead of using the NHS navigation feature toggle.
	const hasNhsNavigation = useFeatureFlag('PatientWeb.NHS.Navigation');
	const callToAction = isReschedule
		? withTranslation('Appointment.AppointmentInfo.Rebooking.Success.GoToAppointment.Button')
		: withTranslation('View.Booking.ScreenDone.Button');

	useEffect(() => {
		analyticCtx.service.trackPageView({
			customTitle: 'Booking: Done',
		});
	}, [analyticCtx]);

	function handleNextClick() {
		analyticCtx.trackEvent('Clicked', 'Go to appointment button');

		// Client-side routerService.navigateByUrl leaves this flow's route tree stuck rendered
		// after leaving a flow route (e.g. this booking flow); a real URL change reliably resets it.
		// The router's basename (licence holder alias) isn't applied to window.location, so it's prepended here.
		const path = params.ticket ? `visits/video/${params.ticket}` : 'visits';
		window.location.href = getAbsoluteRoute([universalConfig.alias, path].filter(Boolean).join('/'));
	}

	return (
		<>
			<TopBar.Content onAbort={null} />
			<IllustrativeView
				title={
					isReschedule
						? withTranslation('Appointment.AppointmentInfo.Rebooking.Success.Title')
						: withTranslation('View.Booking.ScreenDone.Title')
				}
				description={
					isReschedule
						? withTranslation('Appointment.AppointmentInfo.Rebooking.Success.Description')
						: withTranslation('View.Booking.ScreenDone.Description')
				}
				illustration='messageSent'
				callToAction={hasNhsNavigation ? undefined : callToAction}
				callToActionCallback={handleNextClick}
			/>
		</>
	);
}
